import { createFileRoute } from '@tanstack/react-router';
import { isPermissionFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/manifesto-carga')({
    beforeLoad: () =>
        validateRoute({
            fintech: false,
            validatePermission: ({ upp_fiscal_mdfe }) => isPermissionFull(upp_fiscal_mdfe),
        }),
});
